import { AssetLibraryGalleryGridItemBase } from './AssetLibraryGalleryGridItemBase';
import { useAssetLibraryItemGesturesDesktop } from './hooks';
import { type AssetLibraryGalleryGridItemBranchProps } from './types';

export const AssetLibraryGalleryGridItemDesktop = ({
    asset,
    isSelected,
    onClickAsset,
    onClickAssetPreview,
    onClickDownload,
    onClickOpenActions,
    onClickSelectItem,
    onOpenItem,
    t,
}: AssetLibraryGalleryGridItemBranchProps): JSX.Element => {
    const itemActions = useAssetLibraryItemGesturesDesktop({
        onOpenItem,
        onTap: () => onClickAsset?.(asset),
    });

    return (
        <AssetLibraryGalleryGridItemBase
            asset={asset}
            isSelected={isSelected}
            itemActions={itemActions}
            t={t}
            onClickAssetPreview={onClickAssetPreview}
            onClickDownload={onClickDownload}
            onClickOpenActions={onClickOpenActions}
            onClickSelectItem={onClickSelectItem}
        />
    );
};

AssetLibraryGalleryGridItemDesktop.displayName = 'AssetLibraryGalleryGridItemDesktop';
